import React, { useEffect, useRef, useState } from "react";
import { CircularIndeterminate, FormButton } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { SFHabitacionIns } from "services/services-mia/SFHabitacionIns";
import { SFUsuarioHotelGet } from "services/services-mia/SFUsuarioHotelGet";
import { GENERO_OPTIONS } from "consts/hotel";

export default function InsertModal({ updateList, closeModal, defaultHotelId }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);
    const [hoteles, setHoteles] = useState([]);
    const formikRef = useRef();

    useEffect(() => {
        (async () => {
            const result = await SFUsuarioHotelGet(credentials);
            if (Array.isArray(result) && result[0]?.SFHotelId) {
                setHoteles(result);
            }
        })();
    }, [credentials]);

    const handleCreate = async (values) => {
        setInRequest(true);
        const response = await SFHabitacionIns(credentials, {
            SFHotelId: Number(values.hotelId),
            SFHabitacionNumero: values.numero,
            SFHabitacionPiso: values.piso,
            SFHabitacionPlazas: values.plazas,
            SFHabitacionGenero: values.genero,
        });
        setInRequest(false);
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Habitación creada correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        }
    };

    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                hotelId: defaultHotelId || "",
                numero: "",
                piso: "",
                plazas: "",
                genero: "",
            }}
            validationSchema={yup.object({
                hotelId: yup.number().required("Debe seleccionar un hotel"),
                numero: yup.string().required("Debe ingresar el número"),
                piso: yup.string().required("Debe ingresar el piso"),
                plazas: yup.string().required("Debe ingresar las plazas"),
                genero: yup.string().required("Debe seleccionar el género"),
            })}
            onSubmit={handleCreate}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-2"]}>
                    <div className={styles["span-2"]}>
                        <FormikSelectInput disabled={true} name="hotelId" labelText="Hotel">
                            <option value="">Seleccionar hotel</option>
                            {hoteles.map((hotel) => (
                                <option key={hotel.SFHotelId} value={hotel.SFHotelId}>
                                    {hotel.SFHotelNombre}
                                </option>
                            ))}
                        </FormikSelectInput>
                    </div>
                    <FormikTextInput name="numero" labelText="Número" />
                    <FormikTextInput name="piso" labelText="Piso" />
                    <FormikTextInput name="plazas" labelText="Plazas" />
                    <FormikSelectInput name="genero" labelText="Género">
                        <option value="">Seleccionar género</option>
                        {GENERO_OPTIONS.map(({ value, label }) => (
                            <option key={value} value={value}>
                                {label}
                            </option>
                        ))}
                    </FormikSelectInput>
                    <div className={styles.actions}>
                        <FormButton
                            inRequest={inRequest}
                            newFormData={{ button: "Crear" }}
                            onCloseModal={closeModal}
                        />
                        {inRequest && <CircularIndeterminate />}
                    </div>
                </div>
            </Form>
        </Formik>
    );
}
